import React, { useEffect, useContext } from "react";
import Button from "../../components/SignupLogin/Button";
import classes from "../SignupPage/Signup.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FontAwesome from "../SignupPage/FontAwesome";
import Input from "../../components/SignupLogin/Input";
import { PWD_REGEX, EMAIL_REGEX } from "../SignupPage/REGEX_VALUES";

import { UserContext } from "../../context/userContext.js";

const LoginForm = () => {
  const [, setUserContext] = useContext(UserContext);
  const token = localStorage.getItem("token");
  console.log(`TOKEN ${token}`);
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);

  const [btnDisable, setBtnDisable] = useState(true);

  const navigate = useNavigate();

  //   Validating email when the new input is given
  useEffect(() => {
    const result = EMAIL_REGEX.test(email);

    setValidEmail(result);
  }, [email]);

  //   Validating password when the new input is given
  useEffect(() => {
    const result = PWD_REGEX.test(pwd);
    setValidPwd(result);
  }, [pwd]);

  //   Checking if all inputs are valid
  useEffect(() => {
    if (validEmail && validPwd) {
      setBtnDisable(false);
    } else {
      setBtnDisable(true);
    }
  }, [validEmail, validPwd]);

  //   Form Submission Handler

  const formSubmit = (e) => {
    e.preventDefault();
    // Rechecking if all the values are added; to prevent jHack
    if (!validEmail && !validPwd) {
      toast.error("Fill all the required fields");
      return;
    }
    console.log({
      email,
      password: pwd,
    });

    const genericErrorMessage = "Something went wrong! Please try again later.";

    console.log(process.env.REACT_APP_API_ENDPOINT);

    fetch(process.env.REACT_APP_API_ENDPOINT + "users/login", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: email, password: pwd }),
    })
      .then(async (response) => {
        if (!response.ok) {
          if (response.status === 400) {
            toast.error("Please fill all the fields correctly!");
            return;
          } else if (response.status === 401) {
            toast.error("Invalid email and password combination.");
            return;
          } else {
            toast.error(genericErrorMessage);
            return;
          }
        } else {
          const data = await response.json();
          toast.success("Successfully logged in");
          console.log(data.token);
          setTimeout(() => {
            navigate(`/secret-page`);
          }, 3000);

          setUserContext((oldValues) => {
            return { ...oldValues, token: data.token };
          });
        }
      })
      .catch((error) => {
        console.log("here", error);
        toast.error(genericErrorMessage);
        return;
      });
  };
  return (
    <form onSubmit={formSubmit}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      <div className={classes.input_container}>
        <Input
          matchVal={email}
          changeSetVal={(val) => setEmail(val)}
          placeholderText="Email Address"
          validVal={validEmail}
        />
        <FontAwesome validValue={validEmail} value={email} />
      </div>
      <div className={classes.input_container}>
        <Input
          matchVal={pwd}
          changeSetVal={(val) => setPwd(val)}
          placeholderText="Password"
          validVal={validPwd}
        />
        <FontAwesome validValue={validPwd} value={pwd} />
      </div>
      <p className={classes.pwdInfo}>
        *Password must be 6 length or more of alphanumeric characters
      </p>
      <Button
        type={{
          description: "Login with Email",
          color: "#019BFE",
          disabled: btnDisable,
        }}
      />
    </form>
  );
};

export default LoginForm;
